module.exports = __webpack_public_path__ + "images/feature/calendar-notice-928f157368ac3e25b7f95bfe7d321c12.jpg";